// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardLabel_container__pNoxv","text":"DashboardLabel_text__8zTxj","value":"DashboardLabel_value__LzGte"};